export default (() => ({
  currentRoute: null,
  previousRoute: null
}));